<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>개체관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          컨텐츠관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/cs/file">개체 관리</a>
        </li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default" v-show="data.params.mode=='list'" >
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <sch-date-range label="등록일" :data="data"/>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색-->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="page-search mt-3 ml-3">
        <div class="float-left">
          <span class="d-inline-block">결과 내 검색</span>
          <input type="text" class="d-inline-block form-control ml-2" v-model="page.filterWord" @keyup.enter="searchFilter()" style="width: 200px"/>
        </div>
        <div class="float-right mr-3 mt-1">
          <b-button @click="popupAddOpen()" class="btn btn-xs btn-outline-info mr-5" variant="outline-primary">신규등록</b-button>
          <input type="checkbox" class="mt-1" v-model="page.noMapping" @change="search(1)"><span class="d-inline-block ml-1"> 매핑정보 없는 개체만 보기</span>
        </div>
      </div>
      <div class="card-header mt-2">
       <div class="d-inline h3">목록</div>
        <!-- <div class="card-tool float-right">
          <b-button @click="popupAdd = true;" class="btn btn-xs btn-outline-info mr-2" variant="outline-primary">
            New
          </b-button>
        </div> -->
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td class="text-center">개체 ID</td>
              <td class="text-center" @click="localSort.sort('dispFileNm')">노출개체명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td class="text-center">노출대상</td>
              <td class="text-center">개체유형</td>
              <td class="text-center">개체출저</td>
              <td class="text-center" @click="localSort.sort('updDt')">수정일/수정자<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td class="text-center" width="80">Action</td>
            </tr>
          </thead>
          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="7">No matching records</td>
          </tr>
          <tr v-show="data.count>0" v-for="(item, index) in data.list" :key="index">
            <td class="text-center">{{ item.fileSeq }}</td>
            <td>{{ item.dispFileNm }}</td>
            <td class="text-center">
              <span v-show="item.teacherUseYn == 'Y'" class="mr-1 ml-1" :style="{color: item.teacherUseYn == 'Y' ? '#FF0000' : '' }">(교사)</span>
              <span v-show="item.tutorUseYn == 'Y'" class="mr-1 ml-1" :style="{color: item.tutorUseYn == 'Y' ? '#708090' : '' }">(강사)</span>
              <span v-show="item.studentUseYn == 'Y'" class="mr-1 ml-1" :style="{color: item.studentUseYn == 'Y' ? '#800000' : '' }">(학생)</span>
            </td>
            <td class="text-center">
              <span>{{getFileTypeName(item.fileTypeCd)}}</span>
            </td>
            <td class="text-center">
              <span>{{getFileDivName(item.fileDivCd)}}</span>
            </td>
            <td class="text-center">
              <div>{{item.updDt}}</div>
              <div>({{item.updId}})</div>
            </td>
            <td class="text-center">
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="popupOpen(item);"><em class="fa fa-search"></em></b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)"
                      @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    <b-modal id="fileModal" size="xl" title="개체관리" v-model="page.popupInfo.show" hide-footer>
      <CsFilePageInfo :fileSeq="page.popupInfo.fileSeq" :datainfo="data.params" :contSeq="page.popupInfo.contSeq" :parentType="'file'" @get-data="search()" @modal-state="popupClose"/>
    </b-modal>
    <b-modal id="fileRegModal" size="xl" title="개체등록" v-model="page.popupAdd.show" hide-footer>
      <CsFileUploadPage @get-data="search(1)" @modal-state="popupClose" />
    </b-modal>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsFileList, getCsFileItem,getCsFileListNotMapp, saveCsFile, deleteCsFile} from "@/api/cs/CsFileApi";
import {getCsFileMappingItem, saveCsFileMapping,  deleteCsFileMapping} from "@/api/cs/CsFileMappingApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,purpTypeCd, getFileTypeName, getFileDivName} from "@/utils/Constants";
import CsFilePageInfo from "../cs/CsFilePageInfo"
import CsFileUploadPage from "../cs/CsFileUploadPage"
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";

export default {
  components: {SchDateRange, SchText, Pagenation, CsFilePageInfo, CsFileUploadPage},
  setup(props, {root}) {
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const data = reactive(_dataObject) //reactive 반응형 

    const schOptions = [{value: 'dispFileNm', text: '노출파일명'}, {value: 'fileSeq', text: '개체 ID'}]
    data.schOptions = schOptions // 검색 type 선택 

    const page = reactive({
      popupInfo: {
        show:false,
        fileSeq:0,
        contSeq:0
      },
      popupAdd: {
        show:false,
        fileSeq:0,
        contSeq:0,
      },
      noMapping:false,
      filterWord:'',
      orgDataList:[],
    })

    const search = async (pageNo) => {
      if (pageNo && !isNaN(pageNo)) {
        data.params.page = pageNo;
      }
      data.params.delYn = 'N'; // 삭제된 데이터 제외
      const result = page.noMapping ? await getCsFileListNotMapp(data.params) : await getCsFileList(data.params);
      data.list = result.data;
      data.count = result.count;
      page.orgDataList = _.cloneDeep(data.list);
      root.$_localSort.set(data.list);
    }

    // 결과내 검색
    const searchFilter = async () => {
      //console.log(`searchFilter called:'${page.filterWord}'`);
      const filterWord = page.filterWord.trim();
      const filteredList = page.orgDataList.filter((item) => {
        const index = item.dispFileNm.indexOf(filterWord);
        //console.log('item.dispFileNm, index', item.dispFileNm, index);
        return index != -1;
      });
      data.list = filteredList;
      root.$_localSort.set(data.list);
    }

    const reset = async () => {
      data.params.schType = '';
      data.params.schText = '';
      search(1);
    }

    const popupOpen = (item) => {
      page.popupInfo.fileSeq = item.fileSeq;
      page.popupInfo.contSeq = item.contSeq;
      page.popupInfo.show = true;
    }

    const popupAddOpen = () => {
      page.popupAdd.show = true;
    }

    const popupClose = (item) =>{
      if(item == 'info'){
        page.popupInfo.show=false;
      }else{
        page.popupAdd.show = false;
      }
    }

    const retVals = {
      purpTypeCd,
      getFileTypeName,
      getFileDivName,
      page,
      data,
      search,
      searchFilter,
      reset,
      popupOpen,
      popupAddOpen,
      popupClose,
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }

    onMounted(() => {
      retVals.search();
    })

    return retVals;
  },
}

</script>